Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configReducer;

var _constants = require('../constants');

function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === _constants.ADD_CONFIG) {
    return action.config;
  }

  return state;
}